import { dasherize } from '../dasherize';

type StringToStringObject = {
  [key: string]: string;
};

const PropertyServiceToDbMapping: StringToStringObject = {
  "alexandria city county": "Alexandria County",
  "charlottesville city county": "Charlottesville County",
}

export const propertyPageUrl = (
  countyOrParish: string | null,
  stateOrProvince: string | null,
  hlFullAddress: string | null,
  city: string | null,
  postalCode: string | null,
  uuidFormatted: string | null
) : string => {
  let countyOrParishDb = countyOrParish?.toLowerCase();
  if (countyOrParishDb && PropertyServiceToDbMapping[countyOrParishDb]) {
    countyOrParishDb = PropertyServiceToDbMapping[countyOrParishDb];
  }
  let slug = dasherize(`${countyOrParishDb} ${stateOrProvince}`);
  let addressPropertyUUID = dasherize(
    `${hlFullAddress} ${city} ${stateOrProvince} ${postalCode} ${uuidFormatted}`
  )
  slug = slug.replace(/[.]/gi, '')
  addressPropertyUUID = addressPropertyUUID.replace(/[\s/&%,#.]/ig, '-')
  return `${process.env.REACT_APP_HOMELIGHT_REPO_URL}/homes/${slug}/${addressPropertyUUID}`;
};
